import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Layout as AntdLayout } from "antd";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useWindowSize } from "@devowl-wp/react-utils";
import { Content } from "./content.js";
import { Footer } from "./footer.js";
import { Header } from "./header.js";
import { Sider } from "./sider.js";
import { useTranslation } from "../../others/i18n.js";
import { useStores } from "../../store/root.js";
import { spacing } from "../../styles/spacing.js";
import { ESessionState } from "../../types/store/authentication.js";
var EAdminService = /*#__PURE__*/ function(EAdminService) {
    EAdminService["RealCookieBanner"] = "rcb";
    EAdminService["RealCommerce"] = "rc";
    EAdminService["RealProductManager"] = "rpm";
    return EAdminService;
}(EAdminService || {});
const Layout = ()=>{
    const windowSize = useWindowSize();
    const headerHeight = spacing.layout.header.height;
    const footerHeight = spacing.layout.footer.height;
    const siderWidth = spacing.layout.sider.width;
    const minContentHeight = windowSize.height - headerHeight - footerHeight;
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { notificationStore, rcbAuthenticationStore } = useStores();
    useEffect(()=>{
        notificationStore.clearAll();
    }, [
        location
    ]);
    let activeAdminService = location.pathname.split("/")?.[1];
    activeAdminService = Object.values(EAdminService).includes(activeAdminService) ? activeAdminService : undefined;
    // Get params to retrieve  magic link token
    const [search] = useSearchParams();
    // Timout / Invalid session handling
    useEffect(()=>{
        const invalidSession = search.get("invalidSession");
        const forbidden = search.get("forbidden");
        const isLoginHref = window?.location?.href?.indexOf("/rcb/login") >= 0;
        const isTimeout = rcbAuthenticationStore.sessionState === ESessionState.Stored && rcbAuthenticationStore.session?.validUntil?.getTime() < Date.now();
        if (invalidSession || !isLoginHref && !rcbAuthenticationStore.session?.jwt || isTimeout) {
            rcbAuthenticationStore.sessionDestroy();
            navigate("/rcb/login");
            setTimeout(()=>{
                notificationStore.add({
                    type: "info",
                    message: t("Session has expired. Please sign in again!"),
                    closable: true,
                    duration: 5
                });
            }, 1000);
        } else if (forbidden) {
            navigate({
                pathname: "/forbidden",
                search: new URLSearchParams({
                    message: forbidden
                }).toString()
            });
        }
    }, [
        rcbAuthenticationStore
    ]);
    return /*#__PURE__*/ _jsxs(AntdLayout, {
        children: [
            /*#__PURE__*/ _jsx(Header, {
                headerHeight: headerHeight,
                activeAdminService: activeAdminService
            }),
            /*#__PURE__*/ _jsxs(AntdLayout, {
                children: [
                    /*#__PURE__*/ _jsx(Sider, {
                        siderWidth: siderWidth,
                        activeAdminService: activeAdminService
                    }),
                    /*#__PURE__*/ _jsx(AntdLayout, {
                        children: /*#__PURE__*/ _jsx(Content, {
                            minContentHeight: minContentHeight,
                            children: /*#__PURE__*/ _jsx(Outlet, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Footer, {
                footerHeight: footerHeight
            })
        ]
    });
};
export { Layout, EAdminService };
